<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
               <router-link to="/sale/orders">{{ $t('sale_order') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sale_order_preview') }}</li>
        </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
        <template v-if="header.Status=='Draft'">
            <router-link :to="{ name: 'sale_order_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button v-if="$store.state.userGroup==1" type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
        </template>
        <template v-if="isStockout">
            <router-link :to="{ name: 'sale_stockout_create', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-car"></i> {{$t('request_stockout')}}</router-link>
        </template>
        <template v-if="header.Status=='Nothing To Invoice'">
            <router-link :to="{ name: 'sale_order_invoice_create', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus"></i> {{$t('sale_invoice_create')}}</router-link>
        </template>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print"><i class="fa fa-print"></i> {{ $t('print') }}</button>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <h3 class="text-center" style="font-weight: bold;">{{$t('sale_order')}}</h3>
                <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('customer') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{customer.Name}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('address') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{customer.Address}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('sale_reputation') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{employee.KhmerName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{$t('invoice_no')}}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{header.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(header.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('created_by')}}</td>
                                    <td>:</td>
                                    <td>{{header.CreatedBy}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('approve_by')}}</td>
                                    <td>:</td>
                                    <td>{{header.ApprovedBy}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm no-bor table-scroll">
                            <thead>
                                <tr>
                                    <th class="text-center th-width">{{$t('no')}}</th>
                                    <th class="th-width">{{$t('item_code')}}</th>
                                    <th class="th-width">{{$t('item_name')}}</th>
                                    <th class="text-center th-width">{{$t('qty')}}</th>
                                    <th class="text-center th-width">{{$t('delivery_qty')}}</th>
                                    <th class="text-center th-width">{{$t('uom')}}</th>
                                    <th class="text-right th-width">{{$t('unit_price')}}</th>
                                    <th class="text-right th-width">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemCode}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.ReceiveQty}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$money(ret.Price)}}</td>
                                    <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                   <th colspan="7" class="text-right">{{$t('grand_total')}}</th>
                                   <th class="text-right">{{$money(header.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="7" class="text-right">{{$t('discount')}}</th>
                                    <th class="text-right">{{$money(header.Discount)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="7" class="text-right">{{$t('paid_amount')}}</th>
                                    <th class="text-right">{{$money(header.PaidAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="row" v-if="header.Status!='Draft'">
                    <div class="col-sm-12">
                        <br>
                        <p class="blue" style="font-weight: bold; margin-bottom: 3px;"><i class="fa fa-credit-card" aria-hidden="true"></i> {{$t('sale_invoice')}}</p>
                        <table class="table table-bordered table-sm table-striped no-bor table-scroll">
                        <thead>
                            <tr>
                                <th class="text-center th-width">{{$t('no')}}</th>
                                <th class="th-width">{{$t('code')}}</th>
                                <th class="th-width">{{$t('date')}}</th>
                                <th class="th-width">{{$t('due_date')}}</th>
                                <th class="th-width">{{$t('customer')}}</th>
                                <th class="th-width">{{$t('type')}}</th>
                                <th class="th-width">{{$t('ref_num')}}</th>
                                <th class="th-width">{{$t('grand_total')}}</th>
                                <th class="th-width">{{$t('discount')}}</th>
                                <th class="th-width">{{$t('total_amount')}}</th>
                                <th class="th-width">{{$t('balance')}}</th>
                                <th class="th-width">{{$t('invoice_status')}}</th>
                                <th class="th-width">{{$t('payment_status')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in invoices" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>
                                    <router-link :to="{name: 'sale_invoice_view', params: {id: ret.Id}}">{{ret.Num}}</router-link>
                                </td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{$format(ret.DueDate, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td>{{ret.DocSource}}</td>
                                <td>{{ret.DocSourceNo}}</td>
                                <td class="text-right">{{$money(ret.GrandTotal)}}</td>
                                <td class="text-right">{{$money(ret.Discount)}}</td>
                                <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                                <td class="text-right">{{$money(ret.Balance)}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                <td class="cell-badge" v-html="$statusLabel(ret.PaidStatus)"></td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div class="row" v-if="header.Status!='Draft'">
                    <div class="col-sm-12">
                        <br>
                        <p class="blue" style="font-weight: bold; margin-bottom: 3px;"><i class="fa fa-car" aria-hidden="true"></i> {{$t('stock_out')}}</p>
                        <table class="table table-bordered table-sm table-striped no-bor table-scroll">
                        <thead>
                            <tr>
                                <th class="text-center th-width">{{ $t('no') }}</th>
                                <th class="th-width">{{ $t('code') }}</th>
                                <th class="th-width">{{ $t('date') }}</th>
                                <th class="th-width">{{ $t('type') }}</th>
                                <th class="th-width">{{ $t('ref_num') }}</th>
                                <th class="th-width">{{ $t('branch')}}</th>
                                <th class="th-width">{{ $t('requestor') }}</th>
                                <th class="th-width">{{ $t('customer') }}</th>
                                <th class="th-width">{{$t('status')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in stockouts" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{ name: 'stock_out_preview', params: { id: ret.Id }}">{{ret.Num}}</router-link></td>
                                <td>{{$format(ret.OutDateAt, 'DD-MM-YYYY') }}</td>
                                <td>{{ret.DocSource}}</td>
                                <td>{{ret.DocSourceNo}}</td>
                                <td>{{ret.BranchName}}</td>
                                <td>{{ret.TakerOut}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div class="row" v-if="header.Status!='Draft'">
                    <div class="col-sm-12">
                        <br>
                        <p class="blue" style="font-weight: bold; margin-bottom: 3px;"><i class="fa fa-usd" aria-hidden="true"></i> {{$t('sale_receipt')}}</p>
                        <table class="table table-bordered table-striped table-sm no-bor table-scroll">
                            <thead>
                            <tr>
                                <th class="text-center th-width">{{$t('no')}}</th>
                                <th class="th-width">{{$t('code')}}</th>
                                <th class="th-width">{{$t('date')}}</th>
                                <th class="th-width">{{$t('income_type')}}</th>
                                <th class="th-width">{{$t('description')}}</th>
                                <th class="th-width">{{$t('ref_num')}}</th>
                                <th class="th-width">{{$t('amount')}}</th>
                                <th class="th-width">{{$t('status')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in receipts" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>
                                        <router-link :to="{ name: 'sale_receipt_preview', params:{ id:ret.Id }}">{{ret.Num}}</router-link>
                                    </td>
                                    <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                    <td>{{ret.AccountName}}</td>
                                    <td>{{ret.Description}}</td>
                                    <td>{{ret.InvoiceNum}}</td>
                                    <td class="text-right">{{$money(ret.Amount)}}</td>
                                    <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data: function(){
            return {
                header: {
                    Status: 'None',
                    StockStatus: ''
                },
                customer: {},
                employee: {},
                isStockout: false,
                lines: [],
                invoices: [],
                stockouts: [],
                receipts: []
            }
        },
        created: function(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                var req = {
                    Id: id,
                    IsIncludeInvoice: true,
                    IsIncludeStockout: true,
                    IsIncludeReceipt: true
                };
                this.$api().post('sale/order/find', req).then(res => {
                    if(this.$isValid(res)){
                        let data = res.data.Json;
                        this.header = data.Header;
                        this.lines = data.Lines;
                        this.customer = data.Customer;
                        if(data.Employee != null) this.employee = data.Employee;
                        this.isStockout = data.IsStockout;
                        this.invoices = res.data.Json.Invoices;
                        this.stockouts = res.data.Json.Stockouts;
                        this.receipts = res.data.Json.Receipts;
                    }
                }).finally(function(){ loading.hide(); });
            }
        },
        methods: {
            print: function(){
                window.open('/print/sale/order/' + this.header.Id, '_blank');
            },
            onApproval(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('sale/order/approval', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/sale/orders');
                    }
                }).finally(function(){ loading.hide(); });
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
    .none-bottom{
        border-bottom: none;
        border-top: none;
    }
</style>
